import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { AppFooter } from './components/app'
import { Link } from './components/Link'
import { RouterProvider, useRouter } from './router'

export interface NavItem {
  to: string
  label: string
  isPrivate?: boolean
  hideIfAuth?: boolean
}

export interface AppShellProps {
  navItems: NavItem[]
  children?: ReactNode
  isAuthenticated?: boolean
  onLogout?: () => void
  endSlot?: ReactNode
  brand?: string
}

const AppShellInner = ({
  navItems,
  children,
  isAuthenticated = false,
  onLogout,
  endSlot,
  brand,
}: AppShellProps) => {
  const { t } = useTranslation('common')
  const { currentPath } = useRouter()

  const filteredNavItems = navItems.filter(item => {
    if (item.isPrivate && !isAuthenticated) {
      return false
    }
    if (item.hideIfAuth && isAuthenticated) {
      return false
    }
    return true
  })

  return (
    <>
      <header className="header">
        <nav className="nav">
          {filteredNavItems.map(item => (
            <Link
              key={item.to}
              className={`nav__link ${currentPath === item.to || currentPath.startsWith(`${item.to}/`) ? 'nav__link--selected' : ''}`}
              to={item.to}>
              {item.label}
            </Link>
          ))}
          {isAuthenticated && onLogout && (
            <button
              type="button"
              className="nav__link nav__link--logout"
              onClick={onLogout}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                font: 'inherit',
                color: 'var(--color-error-text)',
              }}>
              {t('nav.logout')}
            </button>
          )}
          {endSlot}
        </nav>
      </header>
      <main className="main">{children}</main>

      <AppFooter brand={brand} />
    </>
  )
}

export const AppShell = (props: AppShellProps) => (
  <RouterProvider>
    <AppShellInner {...props} />
  </RouterProvider>
)
